"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  SERVICE: 'SERVICE',
  CMS: 'CONTENT'
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/HubTypes.js
// module id = 350
// module chunks = 5 6 7